function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import { injectIntl } from "react-intl";
import isEqual from "lodash/isEqual";
var ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(ErrorBoundary, _React_Component);
    var _super = _createSuper(ErrorBoundary);
    function ErrorBoundary(props) {
        _classCallCheck(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.clearError = function() {
            _this.setState({
                hasError: false,
                error: null,
                info: null
            });
        };
        _this.state = {
            hasError: false,
            error: null,
            info: null
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, info) {
        if (!isEqual(error, this.state.error) || !isEqual(info, this.state.info)) {
            this.setState({
                error: error,
                info: info
            });
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentSlide !== this.props.currentSlide) {
            this.clearError();
        }
    };
    _proto.render = function render() {
        var _this_state = this.state, hasError = _this_state.hasError, error = _this_state.error, info = _this_state.info;
        var _this_props = this.props, intl = _this_props.intl, children = _this_props.children;
        if (hasError) {
            // You can render any custom fallback UI
            return /*#__PURE__*/ React.createElement("div", {
                className: "component-error"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "component-error__header"
            }, /*#__PURE__*/ React.createElement("h4", {
                className: "component-error__title"
            }, intl.formatMessage({
                id: "error.boundary.header",
                defaultMessage: "Something went wrong. We apologize for the inconvenience!"
            }))), error && error.message && typeof error.message === "string" ? /*#__PURE__*/ React.createElement("div", {
                className: "component-error__body"
            }, /*#__PURE__*/ React.createElement("p", null, "".concat(intl.formatMessage({
                id: "errorMessage",
                defaultMessage: "Error message"
            }), ":")), /*#__PURE__*/ React.createElement("pre", null, error.message)) : null, info && info.componentStack && typeof info.componentStack === "string" ? /*#__PURE__*/ React.createElement("div", {
                className: "component-error__info"
            }, /*#__PURE__*/ React.createElement("pre", null, info.componentStack)) : null);
        }
        return children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    };
    return ErrorBoundary;
}(React.Component);
export default injectIntl(ErrorBoundary);
